<form nz-form nzLayout="vertical" [formGroup]="form" [class.disabled]="apartmentFacade.status === 2">
  <div nz-row [nzGutter]="[5, 5]">
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 8}">
      <beautyapp-select
        formControlName="serviceId"
        label="{{'calendar.form.procedure' | translate}}"
        placeholder="{{'calendar.form.procedure' | translate}}"
        [withTooltip]="true"
        valueMember="id"
        displayMember="name"
        [data]="services$ | async"
        required
      ></beautyapp-select>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 4}">
      <beautyapp-input
        label="{{'calendar.form.duration' | translate}}"
        placeholder="{{'calendar.form.time' | translate}}"
        formControlName="time"
        [mask]="timeMask"
        required
      ></beautyapp-input>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 4}">
      <beautyapp-input
        label="{{'calendar.form.price' | translate}}"
        placeholder="{{'calendar.form.gel' | translate}}"
        type="number"
        prefixIcon="dollar"
        formControlName="price"
        required
      ></beautyapp-input>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 4}">
      <beautyapp-input
        label="{{'calendar.form.discount' | translate}}"
        placeholder="{{'calendar.form.percent' | translate}}"
        prefixIcon="percentage"
        type="number"
        formControlName="salePercent"
        [min]="0"
        [max]="100"
        (ngModelChange)="changePercentage($event)"
      ></beautyapp-input>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 4}">
      <beautyapp-input
        label="{{'calendar.form.discountedPrice' | translate}}"
        placeholder="{{'calendar.form.gel' | translate}}"
        prefixIcon="dollar"
        type="number"
        formControlName="salePrice"
      ></beautyapp-input>
    </div>
    <div nz-col [nzSpan]="24">
      <div nz-row [nzGutter]="[5, 5]">
        <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 12}">
          <div nz-row [nzGutter]="[5, 5]">
            @if (apartmentFacade.getCurrentEmployee; as selectedEmployee) {
              <div nz-col [nzSpan]="24">
                <nz-form-label [nzSpan]="7">{{'calendar.form.employee' | translate}}</nz-form-label>
                <nz-input-group [nzPrefix]="prefixTemplateUser">
                  <input
                    type="text"
                    nz-input
                    [ngModel]="selectedEmployee.user?.fullName"
                    [ngModelOptions]="{ standalone: true }"
                    [placeholder]="'calendar.form.employee' | translate"
                    readonly
                    />
                </nz-input-group>
                <ng-template #prefixTemplateUser><span nz-icon nzType="user"></span></ng-template>
              </div>
            }
            <!-- micro-39: same gate as the visit form. Without field.employee_salary the
                 API sends the salary as '***'; the server keeps the real value on save. -->
            <div nz-col *ngxPermissionsOnly="['field.employee_salary']">
              <div nz-row [nzGutter]="[5, 5]">
                <div nz-col [nzSpan]="12">
                  <beautyapp-input
                    label="{{'calendar.form.fixatedSalary' | translate}}"
                    placeholder="{{'calendar.form.fixatedSalary' | translate}}"
                    type="number"
                    prefixIcon="dollar"
                    formControlName="salaryFixed"
                    [readonly]="isEmployee"
                  ></beautyapp-input>
                </div>
                <div nz-col [nzSpan]="12">
                  <beautyapp-input
                    label="{{'calendar.form.salary%' | translate}}"
                    placeholder="{{'calendar.form.salary%' | translate}}"
                    prefixIcon="percentage"
                    type="number"
                    formControlName="salaryPercent"
                    [min]="0"
                    [max]="100"
                    [errors]="{ min: 'validators.percentRange', max: 'validators.percentRange' }"
                    [readonly]="isEmployee"
                  ></beautyapp-input>
                  @if (form.get('salePrice')?.value && form.get('salaryPercent')?.value) {
                    <label nz-checkbox formControlName="salaryPercentFromPrice">{{'calendar.form.fromValue' | translate}}</label>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 12}">
          <div nz-row [nzGutter]="[5, 5]">
            <div nz-col [nzSpan]="24">
              <beautyapp-textarea
                formControlName="description"
                label="{{'calendar.form.comment' | translate}}"
                placeholder="{{'calendar.form.comment' | translate}}"
                [rows]="5"
              ></beautyapp-textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<beautyapp-appointment-products
  [serviceId]="form.get('serviceId')?.value"
  [serviceProducts]="serviceProducts"
  [bookingStatus]="bookingStatus"
  (serviceProductsUpdate)="serviceProductsUpdate($event)"
></beautyapp-appointment-products>
<beautyapp-appointment-spec-services
  [serviceId]="form.get('serviceId')?.value"
  [serviceSpecs]="serviceSpecs"
  [bookingStatus]="bookingStatus"
  (serviceSpecsUpdate)="serviceSpecsUpdate($event)"
></beautyapp-appointment-spec-services>
<div *nzModalFooter nz-row >
  <div nz-row nzFlex="initial" [formGroup]="form" nzGutter="15">
    <div nz-col [nzXs]="{ span: 12}" [nzLg]="{ span: 8}">
      <beautyapp-input
        label="{{'calendar.form.numberProcedures' | translate}}"
        placeholder="{{'calendar.form.numberProcedures' | translate}}"
        type="number"
        formControlName="quantity"
      ></beautyapp-input>
    </div>
    <div nz-col [nzXs]="{ span: 12}" [nzLg]="{ span: 8}">
      <beautyapp-input
        label="{{'calendar.form.expenses' | translate}}"
        type="float"
        formControlName="expence"
      ></beautyapp-input>
    </div>
  </div>
  <div nz-col nzFlex="auto"></div>
  <div nz-col nzFlex="initial" style="padding-top: 25px">
    <button nz-button nzType="default" (click)="modal.close()">{{'buttons.close' | translate}}</button>
    <button  type="button" nz-button [disabled]="disabled || apartmentFacade.status === 2" nzType="primary" (click)="submit()">{{'buttons.save' | translate}}</button>
  </div>
</div>
